import { Component } from "react";
import {
  View,
  TouchableOpacity,
  Image,
  Dimensions,
  ScrollView,
  TextInput,
  Text,
  Platform,
  Linking
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import * as Constants from "../utils/Constants";
import * as Animatable from "react-native-animatable";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let styles = {};
let isMobile = false;
let scale = 1;

// Use PNG on mobile (SVG doesn't work with Image component on native)
// Use SVG on web for better quality
const importantImg = Platform.OS === 'web'
  ? require("../images/login/ImportantInfo.png")
  : require("../images/login/ImportantInfo.png");
const imgGreenVector = Platform.OS === 'web'
  ? require("../images/login/greenVector.png")
  : require("../images/login/greenVector.png");
const imgJdsLogo = Platform.OS === 'web'
  ? require("../images/Header/JdsLogo.png")
  : require("../images/Header/JdsLogo.png");
const imgHelpIcon = require("../images/Header/helpIcon.png");
const imgJordanLogo = Platform.OS === 'web'
  ? require("../images/login/jdsJordan.png")
  : require("../images/login/jdsJordan.png");
const closeImageInfo = Platform.OS === 'web'
  ? require("../images/login/close.png")
  : require("../images/login/close.png");
// const videothumb2 = require("../images/home/videothumb2.png");
class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolled: false,
      isVideoPlaying: false,
      brands: [],
      joImgPos: 0,
      hideScrollTopButton: true,
      showModal: false,
      showAvtivateAccount: false,
      showPickedFile: false,
      PickedFileName: '',
      changableStyle: AppStyles.loginButtonStyles,
      changableTextStyle: AppStyles.loginButtonTextStyles,
      changableStyle2: AppStyles.AcitvateButtonStyles,
      changableTextStyle2: AppStyles.AcitvateButtonTextStyles,
      loginError: false,
      showOTPVerification: false,
      accountNumber: '',
      phonNumber: '',
      initComplete: false,
      errorLoginMessage: 'The account details are incorrect or inactive. Please check your details or activate your account.',
    };
  }
  Pressables = {};

  async componentDidMount() {
    const loggedIn = await Commons.checkUserToken();
    if (loggedIn == Constants.LOGGED_IN) {
      this.props.navigation.navigate("shop");
    }
    setTimeout(() => {
      this.setState({ initComplete: true });
    }, 200);
  }

  renderHeaderMobile = () => {
    return (
      <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between" }}>
        <TouchableOpacity onPress={() => window.history.back()} style={{ paddingHorizontal: isMobile ? undefined : 64 }}>
          <Image source={imgJdsLogo} style={{
            width: 35.063,
            height: 37,
            padding: 1,
            resizeMode: "contain",
          }} />
        </TouchableOpacity>
        <TouchableOpacity onPress={() => this.setState({ showModal: true })} style={{ paddingRight: isMobile ? undefined : 64 }}>
          <Image source={imgHelpIcon} style={{ width: 19.2, height: 19.2 }} />
        </TouchableOpacity>
      </View>
    )
  }


  renderImportantInformation = () => {
    return (
      <Animatable.View
        animation="slideInUp"
        duration={500}
        style={{
          width: width,
          height: isMobile ? '150%' : '100%',
          position: 'absolute',
          top: isMobile ? '43%' : 0,
          transform: [{ translateX: -(width - 20) / 2 }, { translateY: -237.5 }],
          zIndex: 1000,
          flexDirection: 'column',
          backgroundColor: '#FFF',
          alignItems: 'center',
          gap: 32,
          borderTopRightRadius: isMobile ? 16 : undefined,
          borderTopLeftRadius: isMobile ? 16 : undefined,
          borderWidth: isMobile ? 1 : undefined,
          borderColor: isMobile ? 'rgba(215, 215, 215, 0.50)' : undefined,
          alignItems: isMobile ? undefined : 'center',
          justifyContent: isMobile ? undefined : 'center',
        }}
      >
        {isMobile && (
          <View style={{ width, alignItems: 'center', justifyContent: 'center' }}>
            <TouchableOpacity
              onPress={() => this.setState({ showModal: false })}
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                width: 30,
                height: 30,
                borderRadius: 15,
                backgroundColor: 'white',
                justifyContent: 'center',
                alignItems: 'center',
                borderColor: Styles.appColor1,
                borderWidth: 1,
              }}
            >
              <Text style={{ color: Styles.appColor1, fontSize: 15 }}>X</Text>
            </TouchableOpacity>
            <View style={{ marginTop: 50 }}>
              <Image source={imgGreenVector} style={{ width: 110.115, height: 101.534 }} />
              <Image source={importantImg} style={{ width: 108.684, height: 92.239, position: 'absolute', top: 8 }} />
            </View>
            <View>
              <Text style={[AppStyles.H2Styles]}>Important information{'\n'}        for sign up</Text>
            </View>
            <Text style={[AppStyles.LabelTextStyles, { textAlign: 'center' }]}>
              This app is exclusively for our customers.
              {'\n'}You need an account assigned by Jordan Drugstore Company
              {'\n'}(JDS). Use the account number provided by JDS and the
              {'\n'}phone number associated with your JDS account.
              {'\n'}
              {'\n'}
              {'\n'}If you’ve already activated your account online, simply Sign
              {'\n'}In. If not, click Activate Online Account to set up your access.
              {'\n'}Need help? Contact us for assistance.
            </Text>
          </View>
        )}

        {!isMobile && (
          <View style={{ display: 'flex', width: 611, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, borderRadius: 16, borderWidth: 1, borderColor: 'rgba(215, 215, 215, 0.50)', backgroundColor: '#FFF' }}>
            <TouchableOpacity
              onPress={() => this.setState({ showModal: false })}
              style={{
                position: 'absolute',
                top: 32,
                right: 32,
              }}
            >
              {/* <Text style={{ color: Styles.appColor1, fontSize: 15 }}>X</Text> */}
              <Image source={closeImageInfo} style={{ width: 14, height: 14 }} />
            </TouchableOpacity>
            <View style={{ marginTop: 120 }}>
              <Image source={imgGreenVector} style={{ width: 110.115, height: 101.534 }} />
              <Image source={importantImg} style={{ width: 108.684, height: 92.239, position: 'absolute', top: 8 }} />
            </View>
            <View style={{ width: 345, flexDirection: 'column', alignItems: 'center', gap: 16, marginBottom: 70 }}>
              <Text style={[AppStyles.H2Styles]}>Important information{'\n'}        for sign up</Text>
              <Text style={[AppStyles.LabelTextStyles, { textAlign: 'center' }]}>
                This app is exclusively for our customers.{'\n'}
                You need an account assigned by Jordan Drugstore Company
                (JDS). Use the account number provided by JDS and the
                phone number associated with your JDS account.
                {'\n'}{'\n'}
                If you’ve already activated your account online, simply Sign
                In. If not, click Activate Online Account to set up your access.
                Need help? Contact us for assistance.
              </Text>
            </View>
          </View>
        )}

      </Animatable.View>
    );
  }




  renderMobile() {
    scale = width / 420;
    return (
      <View style={styles.container}>
        {this.renderHeaderMobile()}
        {this.state.showModal && this.renderImportantInformation()}
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          <View style={{ width }}>
            {Commons.loadFonts(this, false)}
            {Styles.renderVSeparator(0)}
            {this.renderPart1Mobile()}
            {this.renderPart2Mobile()}
            {this.state.showAvtivateAccount && this.renderActivateAccountMobile()}
            {this.state.showOTPVerification && this.renderOTPVerification()}
            {/* {Commons.renderFooter({}, this)} */}
          </View>
        </ScrollView >
        <View style={{ position: 'absolute', bottom: 24, left: 20, flexDirection: 'row', alignItems: 'center', gap: 4 }}>
          <Text style={{ color: '#A0A0A0', fontSize: 12 }}>Jordan Drugstore 2026 ©</Text>
          <TouchableOpacity onPress={() => Linking.openURL('https://jdsco.net/pdf/privacypolicy.pdf')}>
            <Text style={{ color: '#3A6B8A', fontSize: 12, textDecorationLine: 'underline' }}>{STRINGS.privacy_policy}</Text>
          </TouchableOpacity>
        </View>
      </View >
    );
  }

  render() {
    if (!this.state.initComplete) return null;
    Commons.resizeHandle(window, this, () => {
      width = this.width;
      height = this.height;
      this.setState({ width, height });
    });

    width = Dimensions.get("window").width - 2;
    height = Dimensions.get("window").height;
    isMobile = Commons.isMobile();
    if (isMobile) {
      styles = this.styles();
      return this.renderMobile();
    }
    styles = this.styles();
    return (
      <View style={styles.container}>
        {/* <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={"Login"}
        /> */}
        {/* <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}> */}
        {this.renderHeaderMobile()}
        <View>
          {Commons.loadFonts(this, false)}
          {this.renderPart1()}
          {this.state.showModal && this.renderImportantInformation()}
          {/* {this.renderPart2()} */}
          {/* {this.renderPart3()} */}
          {/* {this.renderPart4()} */}
          {/* {this.renderPart5()} */}
          {/* {this.renderPart6()} */}
          {/* {Commons.renderFooter({}, this)} */}
        </View>
        {/* </ScrollView> */}

      </View >
    );
  }



  getCustomerMask = async () => {
    const resp = await ServerOperations.getCustomerPhoneMask(this.state.accountNumber);
    if (resp.ERROR) {
      console.log(resp.ERROR);
      this.setState({ phoneMask: '', loginError: true });
      return;
    }
    const phoneMask = resp.MASK;
    this.setState({ phoneMask, loginError: false });

  }

  renderPart1 = () => {
    var textInputStyle1 = AppStyles.TextInputStyles1Secondary;
    if (this.state.loginError) {
      textInputStyle1 = AppStyles.TextInputStyles4;
    }
    return (
      <View style={{ width, height: height - 90, backgroundColor: '#FFF', alignItems: 'center', justifyContent: 'center' }}>
        <View style={{ position: 'absolute', bottom: 0, right: 30 }}>
          <Image source={imgJordanLogo} style={{ width: 400, height: 500 }} />
        </View>
        <View style={{ width: 375, alignSelf: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.20)', backgroundColor: '#FFF' }}>
          <View style={{ flexDirection: "column", alignItems: "center", alignSelf: "stretch", gap: 8 }}>
            <View style={{ alignItems: "center", justifyContent: "center", alignSelf: "stretch", marginTop: 50 }}>
              <Text style={[AppStyles.H1Styles, { fontSize: 28 }]}>{STRINGS.welcome_back}</Text>
            </View>
            <View style={{ flexDirection: "column", alignItems: "flex-start", gap: 8, alignSelf: "stretch", marginTop: 24, width: 373, paddingHorizontal: 16 }}>
              <View>
                <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Account_Number}</Text>
              </View>
              <TextInput style={[textInputStyle1]}
                value={this.state.accountNumber}
                keyboardType="numeric"
                placeholder={STRINGS.Your_Account_Number}
                placeholderTextColor={'rgba(59, 98, 127, 0.50)'}
                onChangeText={(text) => { this.setState({ accountNumber: text }) }}
                onBlur={() => { if (this.state.accountNumber) this.getCustomerMask(this.state.accountNumber) }}>
              </TextInput>
            </View>

            <View style={{ flexDirection: "column", alignItems: "flex-start", gap: 8, alignSelf: "stretch", width: 373, paddingHorizontal: 16 }}>
              <View>
                <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.phone_number_2}</Text>
              </View>
              <TextInput style={[textInputStyle1]}
                keyboardType="numeric"
                placeholder={this.state.phoneMask ? this.state.phoneMask : STRINGS.Your_Phone_Number}
                placeholderTextColor={'rgba(59, 98, 127, 0.50)'}
                onChangeText={(text) => this.setState({ phonNumber: text })}>
              </TextInput>
            </View>
            {this.state.loginError == true && (
              <View style={{ alignItems: 'flex-start', justifyContent: 'flex-start', marginTop: 10, width: 375, alignSelf: 'stretch', width: 373, paddingHorizontal: 16 }}>
                <Text style={[AppStyles.SecondaryTextStyles, { color: '#D70202' }]}>
                  {this.state.errorLoginMessage}
                </Text>
              </View>
            )}
          </View>

          <View style={{ flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, marginTop: 48, width: 373, paddingHorizontal: 16, marginBottom: 50 }}>
            <TouchableOpacity style={AppStyles.loginButtonStyles}
              onPress={() => {
                loaderHandler.showLoader(STRINGS.loading, this);
                this.checkCustomerPhone()
              }}
            >
              <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.login}</Text>
            </TouchableOpacity>
            <View style={{ flexDirection: 'row', alignItems: "center", gap: 10 }}>
              <View style={{ width: 375 / 2 - 40, height: 1, backgroundColor: '#D7D7D7' }} />
              <Text style={[AppStyles.LabelTextStyles, { color: '#D9D9D9' }]}>or</Text>
              <View style={{ width: 375 / 2 - 40, height: 1, backgroundColor: '#D7D7D7' }} />
            </View>
            <TouchableOpacity style={AppStyles.AcitvateButtonStyles}
              onPress={() => window.location = './activation'}>
              <Text style={AppStyles.AcitvateButtonTextStyles}>{STRINGS.Activate_Account_Number}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }


  renderPart1Mobile = () => {
    return (<View
      style={{

        flexDirection: "column",
        alignItems: "center",
        alignSelf: "stretch",
        marginTop: 60,
        gap: 8,
        paddingHorizontal: 20
      }}>
      <View style={{ alignItems: "center", justifyContent: "center", alignSelf: "stretch" }}>
        <Text style={[AppStyles.H1Styles]}>{STRINGS.welcome_back}</Text>
      </View>
      <View style={{ flexDirection: "column", alignItems: "flex-start", gap: 8, alignSelf: "stretch", marginTop: 24 }}>
        <View>
          <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Account_Number}</Text>
        </View>
        {(this.state.loginError == false) && (
          <TextInput style={[AppStyles.TextInputStyles1Secondary]}
            value={this.state.accountNumber}
            keyboardType="numeric"
            placeholder={STRINGS.Your_Account_Number}
            placeholderTextColor={'#3b627f80'}
            onChangeText={(text) => { this.setState({ accountNumber: text }) }}
            onBlur={() => { if (this.state.accountNumber) this.getCustomerMask(this.state.accountNumber) }}>
          </TextInput>
        )}
        {(this.state.loginError == true) && (
          <TextInput style={[AppStyles.TextInputStyles4, { color: AppStyles.appColor1 }]}
            value={this.state.accountNumber}
            placeholder={STRINGS.Your_Account_Number}
            keyboardType="numeric"
            placeholderTextColor={AppStyles.appColor1}
            onChangeText={(text) => { this.setState({ accountNumber: text }) }}
            onBlur={() => { if (this.state.accountNumber) this.getCustomerMask(this.state.accountNumber) }}>
          </TextInput>
        )}
      </View>

      <View style={{ flexDirection: "column", alignItems: "flex-start", gap: 8, alignSelf: "stretch" }}>
        <View>
          <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.phone_number_2}</Text>
        </View>
        {this.state.loginError == false && (
          <TextInput style={[AppStyles.TextInputStyles1Secondary]}
            keyboardType="numeric"
            placeholder={this.state.phoneMask ? this.state.phoneMask : STRINGS.Your_Phone_Number}
            placeholderTextColor={'#3b627f80'}
            onChangeText={(text) => this.setState({ phonNumber: text })}>
          </TextInput>
        )}
        {this.state.loginError == true && (
          <TextInput style={[AppStyles.TextInputStyles4, { color: AppStyles.appColor1 }]}
            keyboardType="numeric"
            placeholder={this.state.phonNumber}
            placeholderTextColor={AppStyles.appColor1}>
          </TextInput>
        )}
      </View>
      {this.state.loginError == true && (
        <View style={{ alignItems: 'flex-start', justifyContent: 'flex-start', marginTop: 10, width: width - 40, alignSelf: 'stretch' }}>
          <Text style={[AppStyles.SecondaryTextStyles, { color: '#D70202' }]}>
            {this.state.errorLoginMessage}
          </Text>
        </View>
      )}
    </View>

    )
  }

  renderPart2 = () => {

  }

  checkCustomerPhone = async () => {
    const resp = await ServerOperations.checkCustomerPhone(this.state.accountNumber, this.state.phonNumber);
    if (resp.ERROR) {
      console.log(resp.ERROR);
      this.setState({ loginError: true, errorLoginMessage: 'The account details are incorrect or inactive. Please check your details or activate your account' });
      setTimeout(() => {
        loaderHandler.hideLoader();
      }, 300);
      return;
    }
    Commons.saveToAS(Constants.CUST_CODE, this.state.accountNumber);
    Commons.saveToAS(Constants.PHONE, this.state.phonNumber);
    setTimeout(() => {
      loaderHandler.hideLoader();
      window.location = './OtpVerification';
    }, 1500);
  };

  renderPart2Mobile = () => {
    return (
      <View style={{ flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, marginTop: 48, paddingHorizontal: 20 }}>
        <TouchableOpacity style={AppStyles.loginButtonStyles}
          onPress={() => {
            loaderHandler.showLoader(STRINGS.loading, this);
            this.checkCustomerPhone()
          }}
        >
          <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.login}</Text>
        </TouchableOpacity>
        <View style={{ flexDirection: 'row', alignItems: "center", gap: 10 }}>
          <View style={{ width: width / 2 - 40, height: 1, backgroundColor: '#D7D7D7' }} />
          <Text style={[AppStyles.LabelTextStyles, { color: '#D9D9D9' }]}>or</Text>
          <View style={{ width: width / 2 - 40, height: 1, backgroundColor: '#D7D7D7' }} />
        </View>
        <TouchableOpacity style={AppStyles.AcitvateButtonStyles}
          onPress={() => window.location = './activation'}>
          <Text style={AppStyles.AcitvateButtonTextStyles}>{STRINGS.Activate_Account_Number}</Text>
        </TouchableOpacity>
      </View>
    );
  }

  renderPart3 = () => {
  }

  renderPart3Mobile = () => {

  }





  styles = () => ({
    container: {
      flex: 1,
      width: width,
      alignItems: "center",
      backgroundColor: WHITE
    },
    image: {
      flex: 1,
      resizeMode: 'contain',
      justifyContent: 'center',
      width,
      height: 590,
    }
  });
}



export default Login;
